import { Service } from '@angular/core';

@Service()
export class UserStateService {

  private collapsedConfigurationSections: ConfigurationSection[];
  redirectUri: string | undefined;
  private readonly COOLING_LOOP_DELTA_VALUE_KEY: string = 'COOLING_LOOP_DELTA';
  private readonly HEATING_LOOP_DELTA_VALUE_KEY: string = 'HEATING_LOOP_DELTA';

  constructor() {
    this.collapsedConfigurationSections = [];
  }

  isConfigurationSectionCollapsed(section: ConfigurationSection): boolean {
    return this.collapsedConfigurationSections.indexOf(section) >= 0;
  }

  setCollapsedValue(section: ConfigurationSection, expanded: boolean): void {
    const index = this.collapsedConfigurationSections.indexOf(section);
    if (expanded) {
      this.collapsedConfigurationSections.splice(index, 1);
    } else if (index < 0) {
      this.collapsedConfigurationSections.push(section);
    }
  }

  getLoopDeltaValue(isCooling: boolean): number {
    const key = isCooling ? this.COOLING_LOOP_DELTA_VALUE_KEY : this.HEATING_LOOP_DELTA_VALUE_KEY;
    const value: string = localStorage.getItem(key)!;
    return +(value || '99999');
  }

  clearLoopDeltaValues(): void {
    localStorage.removeItem(this.COOLING_LOOP_DELTA_VALUE_KEY);
    localStorage.removeItem(this.HEATING_LOOP_DELTA_VALUE_KEY);
  }

  setLoopDeltaValue(isCooling: boolean, value: number): void {
    const key = isCooling ? this.COOLING_LOOP_DELTA_VALUE_KEY : this.HEATING_LOOP_DELTA_VALUE_KEY;
    const stringValue: string = (value || 99999).toString();
    localStorage.setItem(key, stringValue);
  }

}

export enum ConfigurationSection {
  UNIT_INFORMATION,
  RATINGS,
  INDOOR_AIR_QUALITY,
  PERFORMANCE_INPUTS,
  PERFORMANCE_RESULTS,
  MECHANICAL_CONNECTIONS,
  CONTROLS,
  COIL_OPTIONS,
  PRIMARY_VALVE_PACKAGE,
  SECONDARY_VALVE_PACKAGE,
  DRIVE_ASSEMBLY,
  CABINET_FEATURES,
  FLUID_COOLER_SELECTIONS,
  VALVE_PACKAGE_OPTIONS,
  SITE_SURVEY,
  RETURN_AIR_MODULE,
  ACCESS_MODULE,
  COIL_MODULE,
  STANDARD_FEATURES,
  FAN_CURVE_CHART,
  FAN_PERFORMANCE_SUMMARY
}
